export const decayWindowDays = 10;
export const decayWindowMs = decayWindowDays * 86400 * 1000;
export const decayMatchesRequired = 20;
